import BpkIconAirport from '@skyscanner/backpack-web/bpk-component-icon/lg/airports';
import BusIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/bus';
import BpkIconSelfService from '@skyscanner/backpack-web/bpk-component-icon/lg/self-service';
import { TEXT_STYLES } from '@skyscanner/backpack-web/bpk-component-text';
import BpkText from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';

import STYLES from './PickUpType.module.scss';

const PICKUP_TYPES = {
  TERMINAL_DESK: 'TERMINAL_DESK',
  SHUTTLE_BUS: 'SHUTTLE_BUS',
  MEET_AND_GREET: 'MEET_AND_GREET',
};

type TagProps = {
  text: string;
  icon?: React.ReactNode;
};

const Tag = ({ icon = undefined, text }: TagProps) => (
  <div className={STYLES.Tag}>
    {icon && <span className={STYLES.Tag__icon}>{icon}</span>}
    <BpkText textStyle={TEXT_STYLES.bodyDefault} className={STYLES.Tag__text}>
      {text}
    </BpkText>
  </div>
);

type PickUpTypeProps = {
  pickupTypes?: Record<string, string>;
};

const getIcon = (type: string): React.ReactNode | undefined => {
  switch (type) {
    case PICKUP_TYPES.TERMINAL_DESK:
      return <BpkIconAirport />;
    case PICKUP_TYPES.MEET_AND_GREET:
      return <BpkIconSelfService />;
    case PICKUP_TYPES.SHUTTLE_BUS:
      return <BusIcon />;
    default:
      return undefined;
  }
};

const PickUpTypes = ({ pickupTypes = {} }: PickUpTypeProps) => {
  const hasPickupTypes = pickupTypes && Object.keys(pickupTypes).length > 0;
  return (
    <div
      className={`${STYLES.PickUpTypes} ${
        !hasPickupTypes ? STYLES.PickUpTypes__empty : ''
      }`}
    >
      {Object.entries(pickupTypes).map(([typeKey, displayText]) => (
        <Tag key={typeKey} icon={getIcon(typeKey)} text={displayText} />
      ))}
    </div>
  );
};

export default PickUpTypes;
